import { Schema as S } from "effect";

import { defineApi, staticApis } from "../client";
import { UsageExport, UsageSummary } from "../schemas/usage";

export const { exportUsageData, getUsageSummary } = staticApis({
	exportUsageData: ["GET", "/ledger/export", UsageExport],
	getUsageSummary: ["GET", "/ledger/usage/summary", UsageSummary],
});

/** The circle as one Markdown file; the body is the file, not JSON. */
export const exportMarkdown = defineApi("ExportMarkdown", {
	args: {},
	response: S.String,
	read: (response) => response.text,
	request: () => ({ method: "GET", path: "/ledger/export/markdown" }),
});
